import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const CheckIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('CheckIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m1.25 9.306 3.92 3.92 9.58-10.452"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
CheckIcon.id = 'CheckIcon';
CheckIcon.displayName = 'CheckIcon';
export default CheckIcon;
